<div class="main text-white d-flex flex-column justify-content-center align-items-center pt-4 px-4">
    <img width="35" src="assets/Icones/EEYAA_logo1B.png" alt="" srcset="">
    <div class="switchRadio my-5">
        <span class="bold">Talent</span>
        <label class="switch mx-2">
            <input (click)="showProfil()" type="checkbox">
            <span class="slider round"></span>
          </label>
        <span>Client</span>
    </div>
    <input type="text" class="form-control mb-3" name="email" placeholder="Email" id="email">
    <input type="text" class="form-control mb-3" name="password" placeholder="Mot de passe" id="password">
    <label class="container">Se souvenir de moi <br> Mot de passe oublié ?
        <input type="checkbox">
        <span class="checkmark rounded"></span>
      </label>
    <button (click)="login()"  class="w-100 loginBtn text-smaller bg-white color1 py-2 my-4 ">
        Se connecter
    </button>
</div>